module.exports = __webpack_public_path__ + "img/wechat1.65806b3f.jpg";